import React from "react";
var HolidayWatkins = {
  holidayWatkins: function() {
    if (!Fraction.Brand.Graphics.holidayWatkins) {
      return false;
    }
    const watkinses = [
      {
        start: "2017-1-13", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/rubber-ducky.svg",
        title: "Happy Rubber Ducky Day!",
        content: (
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/cDy4PZPMDwU?start=27&autoplay=1"
            frameborder="0"
            allowfullscreen
          />
        )
      },
      {
        start: "2017-2-10", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/umbrella.svg",
        title: "Happy National Umbrella Day!",
        content: (
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/w40ushYAaYA?start=50&autoplay=1"
            frameborder="0"
            allowfullscreen
          />
        )
      },
      {
        start: "2017-3-13", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/earmuffs.svg",
        title: "Happy National Earmuffs Day!",
        content: (
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/HpHRwXXkZnw?autoplay=1"
            frameborder="0"
            allowfullscreen
          />
        )
      },
      {
        start: "2017-4-23", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/shakespeare.svg",
        title: "Happy Talk Like Shakespeare Day!",
        content: (
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/30LupDzYp4s?autoplay=1"
            frameborder="0"
            allowfullscreen
          />
        )
      },
      {
        start: "2017-4-25", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/penguin.svg",
        title: "Happy World Penguin Day!",
        content: (
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/ugllW3tZK3A?autoplay=1"
            frameborder="0"
            allowfullscreen
          />
        )
      },
      {
        start: "2017-5-15", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/doodle_chocolate_chip.svg",
        title: "Happy Chocolate Chip Day!",
        content: (
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/Ye8mB6VsUHw?autoplay=1"
            frameborder="0"
            allowfullscreen
          />
        )
      },
      {
        start: "2017-6-4", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/doodle_cat_hug.svg",
        title: "Happy Hug Your Cat Day!",
        content: (
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/VR7SZhJ98Cc?autoplay=1"
            frameborder="0"
            allowfullscreen
          />
        )
      },
      {
        start: "2017-7-20", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/doodle_space.svg",
        title: "Happy Space Exploration Day!",
        content: (
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/RtU_mdL2vBM?autoplay=1"
            frameborder="0"
            allowfullscreen
          />
        )
      },
      {
        start: "2017-8-9", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/doodle_book_lovers.svg",
        title: "Happy Book Lovers Day!",
        content: (
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/DQfiWFwVF8M?autoplay=1"
            frameborder="0"
            allowfullscreen
          />
        )
      },
      {
        start: "2017-8-21", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/doodle_eclipse.svg",
        title: "Happy Solar Eclipse 2017!",
        content: (
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/HeINuQ56KD4?autoplay=1"
            frameborder="0"
            allowfullscreen
          />
        )
      },
      {
        start: "2017-8-30", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/doodle_toasted_marshmallow.svg",
        title: "Happy Toasted Marshmallow Day!",
        content: (
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/wA6_2cWt00M?autoplay=1"
            frameborder="0"
            allowfullscreen
          />
        )
      },
      {
        start: "2017-10-31", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/doodle_halloween.svg",
        title: "Happy Halloween!",
        content: (
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/TRGkEDADmRU?autoplay=1"
            frameborder="0"
            allowfullscreen
          />
        )
      },
      {
        start: "2017-12-18", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/doodle_bake_cookies.svg",
        title: "Happy Bake Cookies Day!",
        content: (
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/G4fSvtn1HAw?autoplay=1"
            frameborder="0"
            allowfullscreen
          />
        )
      },
      {
        start: "2018-1-14", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/doodle_dress_up_pet.svg",
        title: "Happy Dress Up Your Pet Day!",
        content: (
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/9JVtwLzsMMo?start=8&autoplay=1"
            frameborder="0"
            allowfullscreen
          />
        )
      },
      {
        start: "2018-2-14", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/doodle_valentines.svg",
        title: "Happy Valentines Day!",
        content: (
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/JySkz5VD6TU?autoplay=1"
            frameborder="0"
            allowfullscreen
          />
        )
      },
      {
        start: "2018-3-30", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/doodle_doctor.svg",
        title: "Happy Doctors' Day!",
        content: (
          <div style={{ textAlign: "center" }}>
            <img
              src="/img/holidaywatkins/doodle_doctor.svg"
              style={{ maxHeight: "100%" }}
            />
          </div>
        )
      },
      {
        start: "2018-4-16", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/doodle_marathon.svg",
        title: "Today is the Boston Marathon!",
        content: (
          <div style={{ textAlign: "center" }}>
            <img
              src="/img/holidaywatkins/doodle_marathon.svg"
              style={{ maxHeight: "100%" }}
            />
          </div>
        )
      },
      {
        start: "2018-7-14", // inclusive
        end: "2018-7-16", // exclusive
        graphic: "/img/holidaywatkins/doodle_wimbledon.svg",
        title: "The Finals at Wimbledon",
        content: (
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/cJzwoD1Edc8?autoplay=1"
            frameborder="0"
            allowfullscreen
          />
        )
      },
      {
        start: "2018-8-18", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/doodle_honey_bee.svg",
        title: "Today is National Honey Bee Awareness Day!",
        content: (
          <iframe
            width="100%"
            height="360"
            src="https://www.youtube.com/embed/D5zGAFyn9Vk?autoplay=1"
            frameborder="0"
            allowfullscreen
          />
        )
      },
      {
        start: "2018-9-12", // inclusive
        end: "", // exclusive
        graphic: "/img/holidaywatkins/doodle_chocolate_milkshake.svg",
        title: "Today is National Chocolate Milkshake Day!",
        content: (
          <div style={{ textAlign: "center" }}>
            <img
              src="/img/holidaywatkins/doodle_chocolate_milkshake.svg"
              style={{ maxHeight: "100%" }}
            />
          </div>
        )
      }
    ];
    const launchHolidayWatkins = function(todaysWatkins) {
      Fraction.Helpers.showModal({
        title: todaysWatkins.title,
        content: todaysWatkins.content,
        closeCallback: function() {},
        buttons: [],
        width: 600,
        height: 440,
        definingClass: "holiday-watkins"
      });
    };
    const todaysDate = new Date();
    const today = new Date(
      todaysDate.getFullYear(),
      todaysDate.getMonth(),
      todaysDate.getDate()
    );
    const todaysWatkins = watkinses.find(watkinsee => {
      const startDateParts = watkinsee.start.split("-");
      const endDateParts = watkinsee.end.split("-");
      const startDate = new Date(
        startDateParts[0],
        startDateParts[1] - 1,
        startDateParts[2]
      );
      const endDate = new Date(
        endDateParts[0],
        endDateParts[1] - 1,
        endDateParts[2]
      );
      if (
        today.getTime() === startDate.getTime() ||
        (watkinsee.end &&
          today.getTime() >= startDate.getTime() &&
          today.getTime() < endDate.getTime())
      ) {
        return true;
      }
    });
    if (todaysWatkins) {
      return (
        <div
          aria-hidden="true"
          style={{ cursor: "pointer" }}
          onClick={() => {
            launchHolidayWatkins(todaysWatkins);
          }}
        >
          <object
            style={{ pointerEvents: "none" }}
            type="image/svg+xml"
            data={todaysWatkins.graphic}
            className="logo"
            aria-hidden="true"
          >
            sdf
          </object>
        </div>
      );
    }
    return false;
  }
};

module.exports = HolidayWatkins;
